
<template>

  <div class="settings-outer">
    <div class="settings-frame" v-click-outside="assessClose">
      <div :class="settingsClass">
        <div class="close-settings" @click="closeSettings" v-if="showClose && $screen.breakpoint == 'sm'">
          <h5>x</h5>
        </div>
        <div class="close-settings logout-settings" @click="$router.push({path: '/'})" v-if="showClose && $screen.breakpoint == 'sm'">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/logout.png" />
        </div>
        <nav class="settings-nav">
          <div :class="activeNode === 'org' ? 'settings-nav-node active-settings-node' : 'settings-nav-node'" @click="activeNode = 'org'">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/orgBlack.png" />
          </div>
          <div :class="activeNode === 'team' ? 'settings-nav-node active-settings-node' : 'settings-nav-node'" @click="activeNode = 'team'">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/teamBlack.png" />
          </div>
          <div :class="activeNode === 'opt' ? 'settings-nav-node active-settings-node' : 'settings-nav-node'" @click="activeNode = 'opt'">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/settingsBlack.png" />
          </div>
        </nav>
        <header class="settings-header">
          <h3>{{parseTitle(activeNode)}}</h3>
        </header>
        <div class="settings-body">
          <tab-component
            v-for="tab in settingsTabs"
            :img="tab.img" :title="tab.title"
            :type="tab.type"
            :content="tab.content"
            v-on:switchToggle="toggleSwitch($event)"
          ></tab-component>
        </div>
        <a class="land-btn tre-btn team-btn" v-if="activeNode === 'team'" @click="initNewUser">{{clauses.addMem}}</a>
        <small>2020 Breezi | {{clauses.vers}} 1.9.2</small>
      </div>
    </div>
  </div>

</template>

<script>

  import ClickOutside from 'vue-click-outside';

  import Tab from './Tab';

  import Lang from '@/lib/langTemplates/SettingsTemplate';

  export default {

    data(){
      return {
        settingsClass: 'settings settings-in',
        activeNode: 'org',
        showClose: false,
        settingsTabs: [],
        outsideTimer: false
      }
    },

    components: {
      'tab-component': Tab
    },

    computed: {
      clauses(){
        let lPref = this.$store.state.lang;
        return Object.keys(Lang.clauses).reduce((a, i) => {
          a[i] = Lang.clauses[i][lPref];
          return a;
        }, {});
      }
    },

    methods: {

      closeSettings(){
        const self = this;
        self.settingsClass = 'settings settings-out';
        self.showClose = false;
        setTimeout(() => {
          self.$store.dispatch('togSettings');
        }, 400);
      },

      parseTitle(node){
        switch (node) {
          case 'org':
            return this.clauses.orgDet;
          break;
          case 'team':
            return this.clauses.yourTeam;
          break;
          case 'opt':
            return this.clauses.appSet;
          break;
        }
      },

      setTabs(){
        switch (this.activeNode) {
          case 'org':
          let org = this.$store.state.org;
            this.settingsTabs = [
              {
                img: 'locale',
                type: 'text',
                title: this.clauses.loc,
                content: [
                  org.name,
                  `${org.street} ${org.streetExtended ? org.streetExtended : ''}`,
                  `${org.city}, ${org.state ? org.state : ''}`,
                  `${org.country} ${org.zipCode}`
                ]
              },
              {
                img: 'companyBlue',
                type: 'text',
                title: this.clauses.sum,
                content: this.$store.state.lang === 'en'
                  ? [
                    `<span style="color:#4077BE;">${this.$store.state.buildings.length}</span> Building${this.$store.state.buildings.length === 1 ? '' : 's'} Monitored`,
                    `<span style="color:#4077BE">${this.calcFloors()}</span> Floor${this.calcFloors() === 1 ? '' : 's'} Monitored`,
                    `<span style="color:#4077BE">${this.calcRooms()}</span> Room${this.calcRooms() === 1 ? '' : 's'} Monitored`
                  ]
                  : [
                    this.$store.state.buildings.length + this.clauses.bldgsMonitored,
                    this.calcFloors() + this.clauses.floorsMonitored,
                    this.calcRooms() + this.clauses.roomMonitored
                  ]
              },
              {
                img: 'orders',
                type: 'text',
                title: this.clauses.workOrders,
                content: [
                  this.clauses.coming
                ]
              }
            ]
          break;
          case 'team':
            let team = this.$store.state.team;
            this.$store.dispatch('addMeToTeam');
            this.settingsTabs = team.map(user => {
              return {
                  img: 'user',
                  type: 'text',
                  title: this.getJobTitle(user),
                  content: [
                    user.name,
                    user.email
                  ]
                }
            });
            if (!this.$store.state.user.masterAdmin) this.settingsTabs.unshift({
              img: 'user',
              type: 'text',
              title: 'Master Administrator',
              content: [
                '',
                this.$store.state.org.masterAdmin
              ]
            })
          break;
          case 'opt':
            this.settingsTabs = [
              {
                img: 'units',
                type: 'toggle',
                title: this.clauses.units,
                content: {
                  left: this.clauses.metric,
                  right: this.clauses.std,
                  active: true,
                  ticked: this.$store.state.user.metric ? false : true
                }
              },
              {
                img: 'pressure',
                type: 'toggle',
                title: 'Pressure<br />Units',
                content: {
                  left: 'Pa',
                  right: 'iwg',
                  active: true,
                  ticked: this.$store.state.user.pressure ? false : true
                }
              },
              {
                img: 'locale',
                type: 'toggle',
                title: this.clauses.locale,
                content: {
                  left: this.clauses.cur,
                  right: this.clauses.onsite,
                  active: false,
                  ticked: false
                }
              },
              {
                img: 'lang',
                type: 'toggle',
                title: this.clauses.lang,
                content: {
                  left: 'ENGLISH',
                  right: '日本語',
                  active: true,
                  ticked: this.$store.state.lang === 'jp' ? true : false
                }
              }
            ]
          break;
        }
      },

      calcFloors(){
        return this.$store.state.buildings.reduce((a, i) => {
          return a += (parseInt(i.aboveGround) + parseInt(i.belowGround));
        }, 0);
      },

      calcRooms(){
        return this.$store.state.buildings.reduce((a, i) => {
          return a += i.floors.reduce((x, y) => {
            if (y.rooms) x += y.rooms.length;
            return x;
          }, 0)
        }, 0);
      },

      getJobTitle(u){
        if (u.email === this.$store.state.user.email) {
          return this.clauses.me;
        } else {
          return u.jobTitle ? u.jobTitle : this.clauses.teamMember;
        }
      },

      toggleSwitch(tog){
        try {
          let toggle = this.settingsTabs.find(t => t.img == tog);
          toggle.content.ticked = !toggle.content.ticked;
        } catch(togErr) {
          console.log(togErr);
        }
      },

      assessClose(){
        if (this.outsideTimer) this.closeSettings();
      },

      initNewUser(){
        this.$store.dispatch('togSettings');
        this.$store.dispatch('initOnboard', 'user');
      }

    },

    mounted(){
      const self = this;
      setTimeout(() => {
        self.showClose = true;
        self.outsideTimer = true;
      }, 400);
      this.setTabs();
    },

    watch: {
      activeNode: function(newData, oldData){
        this.setTabs();
      }
    },

    directives: {
      ClickOutside
    }

  }

</script>

<style>

.settings-outer {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0;
  right: 0px;
  background-color: rgb(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.settings-frame {
  width: 550px;
  height: 100%;
  max-height: 800px;
  max-width: 100vw;
  position: relative;
}

.settings-ghost {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.settings {
  width: 100%;
  height: 100%;
  background-color: #dce1ec;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.settings-in {
  animation: settingsin .4s forwards;
}

@keyframes settingsin {
  0% {
    margin-left: 200%;
  }
  100% {
    margin-left: 0%;
  }
}

.settings-out {
  animation: settingsout .4s forwards;
}

@keyframes settingsout {
  0% {
    margin-left: 0%;
  }
  100% {
    margin-left: 200%;
  }
}

.settings-nav {
  width: 220px;
  height: 55px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #1d1d20;
}

.settings-nav-node {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dce1ec;
  border-radius: 100%;
  cursor: pointer;
}

.settings-nav-node img {
  height: 60%;
}

.active-settings-node {
  /* border: 5px solid rgb(0, 153, 191); */
  background: #93c9f6;
  width: 40px;
  height: 40px;
  /* border-radius: 0px; */
}

.active-settings-node img {
  height: 75%;
}

.close-settings {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 2%;
  left: 5%;
  background-color: #1d1d20;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.close-settings h5 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 23px;
}

.settings-header {
  width: 85%;
  margin-top: 20px;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid gray;
  color: #4077BE;
}

.settings-body {
  width: 85%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
}

.team-btn {
  width: 180px;
  background-color: rgba(90, 132, 196, 0.8);
}

.settings small {
  color: #1d1d20;
  width: 100%;
  position: absolute;
  bottom: 1%;
  text-align: center;
}

.logout-settings {
  top: 2%;
  left: 90%;
  background: transparent;
}

.logout-settings img {
  height: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/Settings.vue